export default () => ({
  filters: {
    scope: 'dismissed',
  },
});
